/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import CampHoc from '../../components/CampHoc';

// eslint-disable-next-line react/prop-types
const AloittelijoidenVaellusHettaPallas2027 = ({ data }) => {
  const seo = {
    url: 'https://www.discoverlapland.fi/vaellukset/aloittelijoiden-vaellus-hetta-pallas-2027',
    image: `https://www.discoverlapland.fi${data.imageSEO.childImageSharp.resize.src}`,
    title: 'Aloittelijoiden vaellus Hetta-Pallas 2027',
    description:
      'Onko haaveissasi useamman päivän vaellus Lapissa, mutta syystä tai toisesta se on vielä jäänyt toteuttamatta? Lähde kokemaan legendaarinen Hetta–Pallas-reitti turvallisesti eräoppaan johdolla.',
  };

  return (
    <CampHoc
      heroImage={data.alottelijoidenVaellusBg.childImageSharp.gatsbyImageData}
      seo={seo}
      camp="aloittelijoiden-vaellus-hetta-pallas-2027"
    >
      <div className="camp-text-content">
        <h2>ALOITTELIJOIDEN VAELLUS HETTA-PALLAS</h2>
        <h3>
          17-20.6.2027 <br />
          16-19.9.2027
        </h3>
        <p className="bolded">
          Onko haaveissasi useamman päivän vaellus Lapissa, mutta syystä tai
          toisesta se on vielä jäänyt toteuttamatta? Nyt sinulla on mahdollisuus
          laittaa rinkka selkään ja lähteä kokemaan legendaarinen
          Hetta–Pallas-reitti turvallisesti eräoppaan johdolla. Valmistaudumme
          vaellukseen yhdessä jo ennen lähtöä, joten saat tukea ja tietoa
          ensimmäisistä valmisteluista aina vaelluksen loppuun saakka.
        </p>
        <br />
        <p>
          Hetta–Pallaksen noin 55 kilometrin reitti kulkee upeissa Tunturi-Lapin
          maisemissa Pallas–Yllästunturin kansallispuistossa. Suomen vanhimpiin
          vaellusreitteihin kuuluva Hetta–Pallas linjattiin jo vuonna 1934.
        </p>
        <br />
        <p>
          Päivämatkamme ovat noin 10–15 kilometriä ja vietämme matkalla kolme
          yötä omissa teltoissamme. Reitti kuljettaa meidät tunturien yli,
          avariin maisemiin ja hiljaiseen erämaaluontoon – juuri niihin
          maisemiin, joiden vuoksi Hetta–Pallas on yksi Suomen tunnetuimmista
          vaellusreiteistä.
        </p>
        <br />
        <p>
          Kuljemme vaelluksella rauhalliseen tahtiin ja nautimme
          tunturimaisemista, luonnosta ja vaeltamisesta ilman kiirettä. Voit
          lähteä mukaan ystävän kanssa tai yksin. Vaikka vaellamme ryhmänä ja
          opas on mukana koko matkan, jokainen saa nauttia vaelluksesta myös
          omassa rauhassaan.
        </p>
        <br />
        <p className="bolded">Ennen vaellusta valmistaudumme yhdessä</p>
        <p>
          Ensimmäiselle useamman päivän vaellukselle ei tarvitse lähteä yksin
          arvailemaan, mitä mukaan tarvitaan tai miten retkeen kannattaa
          valmistautua.
        </p>
        <br />
        <p>
          Saat ennen vaellusta kattavat ennakkomateriaalit sekä
          valmennusohjelman, ja tapaamme ryhmän kanssa kahdessa
          online-tapaamisessa. Käymme yhdessä läpi varusteet, vaatetuksen,
          retkiruoat ja niiden valmistuksen sekä muita käytännön asioita.
          Samalla voit kysyä juuri niitä kysymyksiä, joita omaan ensimmäiseen
          vaellukseen valmistautuessa herää.
        </p>
      </div>
      <GatsbyImage
        image={data.alottelijoidenVaellusImg1.childImageSharp.gatsbyImageData}
        className="offering-img"
        alt="image"
      />
      <div className="camp-text-content">
        <p>
          <span className="bolded">17-20.6.2027 vaeltajille:</span>
          <br />
          Ensimmäinen online-tapaaminen on 5.5.2027 klo 19-21 ja viimeinen on
          9.6.2027 klo 19-21.
          <br />
          <span className="bolded">16-19.9.2027 vaeltajille:</span>
          <br />
          Ensimmäinen online-tapaaminen on 5.5.2027 klo 19-21 tai 4.8.2027 klo
          19-21 ja viimeinen on 8.9.2027 klo 19-21.
        </p>
        <br />
        <p className="bolded">Vaelluksen opas</p>
        <p>
          Vaelluksen oppaana toimii Muoniossa asuva Sanni, joka on
          koulutukseltaan eräopas ja fysioterapeutti. Hän toimii oppaana myös
          Discover Laplandin hiihtovaelluksilla.
        </p>
        <br />
        <p>
          Sannille luonnossa liikkumisessa tärkeää eivät ole kiire ja
          suorittaminen, vaan ympäröivä luonto, tunturien rauha ja luonnossa
          syntyvät elämykset. Fysioterapeuttina häntä kiinnostaa myös luonnon ja
          liikkumisen vaikutus ihmisen kokonaisvaltaiseen hyvinvointiin.
        </p>
        <br />
        <p className="bolded">Vaelluksen aikataulu:</p>
        <p>
          Vaelluksen ensimmäisenä päivänä tapaaminen on klo 09.00 Hetassa.
          Hetassa otamme veneen Ounasjärven yli, josta vaellus alkaa. Vaellus
          kestää neljä päivää ja matkalla nukumme teltoissa kolme yötä. Vaellus
          päättyy Pallakselle, jossa olemme noin klo 15.00.
        </p>
        <br />
        <p className="bolded">Mitä tarvitset mukaasi vaellukselle?</p>
        <p>
          - Vaellukseen sekä eri säihin sopivat vaatteet ja kengät
          <br />
          - Teltta, makuualustat sekä makuupussi
          <br />
          - Rinkka
          <br />- Ruuantekovälineet, ruokaa, vesipullo / termospullo
        </p>
      </div>
      <GatsbyImage
        image={data.alottelijoidenVaellusImg2.childImageSharp.gatsbyImageData}
        className="offering-img"
        alt="image"
      />
      <div className="camp-text-content">
        <p className="bolded">Vaatimustaso:</p>
        <p>
          Vaellus on tarkoitettu aloittelijoille, joten aikaisempaa kokemusta
          useamman päivän vaelluksista ei tarvita. Hyvä peruskunto kuitenkin
          tarvitaan.
        </p>
        <br />
        <p>
          Päivämatkat ovat noin 10–15 kilometriä, ja kannat koko vaelluksen ajan
          omat varusteesi rinkassa. Reitillä on pitkiä nousuja ja laskuja sekä
          paikoin kivikkoista maastoa.
        </p>
        <br />
        <p>
          Saat meiltä hyvissä ajoin valmennusohjelman, jonka avulla voit
          valmistautua vaellukseen fyysisesti. Lähtökohtana on kuitenkin se,
          että liikut jo ennestään säännöllisesti ja pystyt kulkemaan useita
          tunteja päivässä vaihtelevassa maastossa.
        </p>
        <br />
        <p>
          Sinun ei tarvitse olla kokenut vaeltaja – sitä varten opas on mukana.
        </p>
        <br />
        <p className="bolded">
          Vaelluksen hinta on 425 € / henkilö (sis. alv.)
        </p>
        <br />
        <p className="bolded">Hintaan sisältyy:</p>
        <p>
          Neljän päivän opastettu Hetta–Pallas-vaellus
          <br />
          Tarkka pakkaus- ja varustelista, jota voit hyödyntää myös tulevilla
          vaelluksillasi
          <br />
          Päiväkohtainen retkisuunnitelma
          <br />
          Valmennusohjelma pitkälle vaellukselle valmistautumiseen
          <br />
          Turvallisuussuunnitelma ja riskianalyysi, jotka auttavat hahmottamaan
          vaellukseen liittyviä riskejä ja turvallisuustekijöitä myös omia
          tulevia vaelluksia suunnitellessa
          <br />
          Kaksi ennen vaellusta järjestettävää online-tapaamista, joissa
          valmistaudumme yhdessä tulevaan vaellukseen ja käymme läpi varusteet,
          vaatetuksen, retkiruoat sekä muut käytännön asiat.
          <br />
          Vaelluskohtainen WhatsApp-ryhmä
        </p>
        <br />
        <p>
          Osallistumismaksun lisäksi osallistuja maksaa itse Hetan
          venekuljetuksen (20 €) sekä Hannukurun saunamaksun (15 €).
        </p>
        <br />
        <p className="bolded">
          Ilmoittaudu mukaan sähköpostitse osoitteeseen{' '}
          <a className="bolded" href="mailto:anettelatvapiikkila@gmail.com">
            anettelatvapiikkila@gmail.com
          </a>{' '}
          ja toimi näin:
        </p>
        <p>
          OTSIKKO: ALOITTELIJOIDEN VAELLUS HETTA–PALLAS + sen vaelluksen
          päivämäärät, jolle haluat osallistua.
          <br />
          Koko nimi:
          <br />
          Ikä:
          <br />
          Puhelinnumero:
          <br />
          Paikkakunta:
          <br />
          Millainen aikaisempi kokemus sinulla on luonnossa liikkumisesta ja
          retkeilystä?
          <br />
          Millainen kuntotasosi on? Kuinka paljon ja millä tavoin liikut
          normaalisti arjessa ja vapaa-ajalla?
          <br />
          Onko terveydentilassasi, toimintakyvyssäsi tai mahdollisissa vammoissa
          jotain, mikä meidän olisi hyvä tietää vaelluksen turvallisen
          toteuttamisen kannalta? Esimerkiksi astma, polvi-, lonkka-, selkä- tai
          nivelongelmat, aiemmat vammat tai muu fyysiseen rasitukseen vaikuttava
          tekijä:
        </p>
        <br />
        <p>
          Ilmoittautumiseen, maksamiseen ja peruutuksiin sovelletaan Discover
          Laplandin{' '}
          <Link className="bolded" to="/varaus-ja-peruutusehdot/">
            varaus- ja peruutusehtoja
          </Link>
          .
        </p>
        <br />
        <p>Tavoitteena ei ole vain päästä Hetasta Pallakselle.</p>
        <br />
        <p>
          Neljän päivän aikana saat kokea Tunturi-Lapin upeat maisemat
          turvallisesti oppaan johdolla ja omaan tahtiin, mutta samalla opit
          taitoja, joista on hyötyä vielä pitkään tämän retken jälkeen.
        </p>
        <br />
        <p>
          Kun saavut Pallakselle rinkka selässä, takana on noin 55 kilometriä
          tuntureita ja kolme yötä teltassa. Seuraavaa retkeä suunnitellessasi
          tiedät jo paljon paremmin, mitä tarvitset, miten valmistaudut ja mitä
          vaelluksella kannattaa ottaa huomioon.
        </p>
        <br />
        <p>
          Ehkä Hetta–Pallas on ensimmäinen vaelluksesi – mutta sen ei tarvitse
          jäädä viimeiseksi.
        </p>
        <br />
        <p>
          Tekisikö mieli mukaan tälle ainutlaatuiselle vaellukselle? Mikäli
          sinulla on kysyttävää vaelluksesta, voit olla yhteydessä Anetteen joko
          meilitse{' '}
          <a className="bolded" href="mailto:anettelatvapiikkila@gmail.com">
            anettelatvapiikkila@gmail.com
          </a>{' '}
          tai soittamalla 040 772 4124.
        </p>
      </div>
    </CampHoc>
  );
};

export const query = graphql`
  {
    alottelijoidenVaellusBg: file(
      relativePath: { eq: "images/hikes/hetta_pallas_2048px-2.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    alottelijoidenVaellusImg1: file(
      relativePath: { eq: "images/hikes/hetta-pallas-2020-1.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    alottelijoidenVaellusImg2: file(
      relativePath: { eq: "images/hikes/hetta-pallas-2020-4.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    imageSEO: file(
      relativePath: { eq: "images/hikes/hetta_pallas_2048px-2.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 1366, layout: FIXED)
        resize(width: 1366, height: 768, quality: 90) {
          src
        }
      }
    }
  }
`;

export default AloittelijoidenVaellusHettaPallas2027;
